import { render } from "./ExternalLinkButton.vue?vue&type=template&id=65aa6b10&scoped=true"
import script from "./ExternalLinkButton.vue?vue&type=script&lang=js"
export * from "./ExternalLinkButton.vue?vue&type=script&lang=js"

import "./ExternalLinkButton.vue?vue&type=style&index=0&id=65aa6b10&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-65aa6b10"

export default script